// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CancelPostPaymentErrorStep extends React.Component {

    constructor(props) {
        super(props);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    goBackHandler() {
        this.props.history.push('/myprofile/cards');
    }
    render() {
        const title = formatText('accountModifyErrorStep-title');
        const subTitle = formatText('accountModifyErrorStep-subTitle');
        const goBackButtonLabel = formatText('cardPaymentPurchaseDeferralSuccess-goBackButton').toUpperCase();

        return (
            <article className="card-mobile-recharge-error row no-gutter">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={subTitle}
                    textLink={goBackButtonLabel}
                    goBackHandler={this.goBackHandler}
                />
            </article>
        )
    }
}

CancelPostPaymentErrorStep.propTypes = {
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = withRouter(CancelPostPaymentErrorStep);
